import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showVoucherExplanation as showVoucherExplanationSelector } from 'ggApp/modules/featureFlag/selectors';
import { PureTranslator } from 'ggApp/modules/translator';
import { PAYMENT_SERVICE_METHOD_TYPE } from 'ggApp/utils/detectPayment';
import isFunction from 'ggApp/utils/function/isFunction';
import { PaymentGatewayList } from 'ggApp/shared/common/Payment/PaymentGatewayList';
import { VocherExplenation } from 'ggApp/modules/newCheckout/components/VocherExplenation';

import { Wrap, Title, SubTitle, BackButton } from './styles';
import GatewaySelectorUi from '../Ui/GatewaySelector';

const Add = ({
    className,
    stepData,
    handleBackButtonClick,
    orderNumber,
    onAdded,
    onLegacyAdded,
    preflightActive,
    setPreflight,
    paymentTermsInfo,
    setPaymentTermsInfo,
    inEditMode,
    showVoucherExplanation,
}) => {
    const onPaymentMethodCreated = useCallback(
        (paymentMethodId, billingAccountId) => {
            if (isFunction(onAdded)) {
                onAdded({
                    id: paymentMethodId,
                    billingAccountId,
                    type: PAYMENT_SERVICE_METHOD_TYPE,
                });
            }
        },
        [onAdded],
    );

    const onLegacyPaymentMethodCreated = useCallback(
        (data) => {
            if (data) {
                if (isFunction(onAdded)) {
                    onLegacyAdded();
                }
            }
        },
        [onAdded, onLegacyAdded],
    );

    return (
        <Wrap className={className} data-testid="add-payment-step">
            {!preflightActive && !paymentTermsInfo && (
                <>
                    <Title>
                        <PureTranslator tk={stepData.title} />
                    </Title>
                    <SubTitle>
                        <PureTranslator tk={stepData.subTitle} />
                    </SubTitle>
                </>
            )}

            <PaymentGatewayList
                orderNumber={orderNumber}
                onPaymentMethodCreated={onPaymentMethodCreated}
                onLegacyPaymentMethodCreated={onLegacyPaymentMethodCreated}
                uiComponent={GatewaySelectorUi}
                onRedirectPreflight={() => setPreflight(true)}
                paymentTermsInfo={paymentTermsInfo}
                setPaymentTermsInfo={setPaymentTermsInfo}
            />

            {showVoucherExplanation?.variantKey === 'payment_methods' ? (
                <VocherExplenation />
            ) : null}

            {!preflightActive && !paymentTermsInfo && inEditMode && (
                <BackButton fullWidth outlined type="button" onClick={handleBackButtonClick}>
                    <PureTranslator tk="NEW_CHECKOUT_HOME_BACK_BTN" />
                </BackButton>
            )}
        </Wrap>
    );
};

Add.propTypes = {
    className: PropTypes.string,
    stepData: PropTypes.shape({}),
    handleBackButtonClick: PropTypes.func,
    onAdded: PropTypes.func,
};

Add.defaultProps = {
    className: undefined,
    stepData: {},
    handleBackButtonClick: () => null,
    onAdded: () => null,
};

const enhance = compose(
    connect(
        createStructuredSelector({
            showVoucherExplanation: showVoucherExplanationSelector,
        }),
    ),
);

export default enhance(Add);
